import { JsonObject, JsonProperty } from 'json2typescript';


@JsonObject('Partner')
export class Partner {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('client_id', Number, true)
    clientId: number = undefined;

    @JsonProperty('name', String, true)
    name: string = null;

    @JsonProperty('name_ar', String, true)
    nameAr: string = null;

    @JsonProperty('phone', String, true)
    phone: string = null;

    @JsonProperty('email', String, true)
    email: string = null;

    @JsonProperty('title', String, true)
    title: string = null;

    @JsonProperty('street_address', String, true)
    streetAddress: string = null;

    @JsonProperty('city', String, true)
    city: string = null;

    @JsonProperty('country', String, true)
    country: string = null;

    @JsonProperty('documents', [Document], true)
    documents: Document[] = [];

    @JsonProperty('created_date', String, true)
    createdDate = null;

    @JsonProperty('updated_date', String, true)
    updatedDate = null;

    get location() {
        return this.city + ', ' + this.country;
    }

    get address() {
        return this.streetAddress + '\n' + this.location;
    }

    get fullName() {
        return this.name + (this.name && this.nameAr ? ' - ' : '') + this.nameAr;
    }
}

